module.exports = __webpack_public_path__ + "media/images/OPL 168-8dfbf93d5a1eaccf69bdc26902a8920e.png";